// Mirror of /app/backend/hub_crm/permissions.py — kept intentionally
// small so it never gets out of sync with the backend's source of
// truth. Every write is enforced server-side; this file only decides
// which UI chrome to show/hide.

const NORM = (role) => {
  if (!role) return 'readonly';
  const r = String(role).trim().toLowerCase();
  if (r === 'director') return 'admin';
  if (r === 'viewer') return 'readonly';
  return r;
};

const MATRIX = {
  admin: {
    view_all: true, edit_any: true, override_soft_gate: true,
    create_lead: true, run_automations: true, drag_drop: true,
  },
  manager: {
    view_all: true, edit_any: true, override_soft_gate: true,
    create_lead: true, run_automations: true, drag_drop: true,
  },
  broker: {
    view_own: true, edit_own: true, override_soft_gate: true,
    create_lead: true, run_automations: true, drag_drop: true,
  },
  credit: {
    view_credit: true, edit_credit: true,
    create_lead: false, run_automations: true, drag_drop: false,
  },
  csm: {
    view_own: true, edit_portal: true,
    create_lead: true, run_automations: false, drag_drop: false,
  },
  settlements: {
    view_settlements: true, edit_settlement: true,
    create_lead: false, run_automations: false, drag_drop: false,
  },
  marketing: {
    view_all: true, read_only: true,
    create_lead: false, run_automations: false, drag_drop: false,
  },
  readonly: {
    view_all: true, read_only: true,
    create_lead: false, run_automations: false, drag_drop: false,
  },
};

/** True if the user's role blocks every mutation. */
export function isReadOnly(user) {
  const role = NORM(user?.role);
  return !!(MATRIX[role]?.read_only);
}

/** True if a role capability is enabled. */
export function can(user, key) {
  const role = NORM(user?.role);
  return !!(MATRIX[role]?.[key]);
}

/** Friendly label for the role. */
export function roleLabel(user) {
  const role = NORM(user?.role);
  return {
    admin: 'Admin', manager: 'Manager', broker: 'Broker',
    credit: 'Credit', csm: 'CSM', settlements: 'Settlements',
    marketing: 'Marketing', readonly: 'Read-only',
  }[role] || role;
}

/** The tooltip we show when a UI action is unavailable to this role. */
export function whyBlocked(user, action) {
  const role = NORM(user?.role);
  if (MATRIX[role]?.read_only) return 'Your role is read-only.';
  if (action === 'drag_drop') return 'Your role cannot move deals between stages. Ask a broker or manager.';
  if (action === 'create_lead') return 'Your role cannot create leads.';
  if (action === 'override_soft_gate') return 'Your role cannot override stage gates. Ask a manager or an admin.';
  return 'This action is not available for your role.';
}
